module.exports = __webpack_public_path__ + "static/media/onboarding-engage.a16ee445.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboarding-engage.svg
// module id = 353
// module chunks = 0